import HighlightedPickers from './HighlightedPickers.vue'

export default HighlightedPickers
